import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: 100,
    },
    progress: {
        height: '67.2px',
        width: '33.6px',
        animation: '$progressRotate 2s ease infinite',
    },
    top: {
        backgroundColor: '#dbdcef',
        backgroundImage: 'linear-gradient(#2e9e9e, #2e9e9e)',
        backgroundSize: '33.6px 33.6px',
        backgroundRepeat: 'no-repeat',
        width: '33.6px',
        height: '33.6px',
        backgroundPosition: '0 0',
        animation: '$progressTop 2s ease infinite',
        WebkitClipPath: 'polygon(0% 0%, 100% 0%, 50% 100%)',
        clipPath: 'polygon(0% 0%, 100% 0%, 50% 100%)',
    },
    bottom: {
        backgroundColor: '#dbdcef',
        backgroundImage: 'linear-gradient(#2e9e9e, #2e9e9e)',
        backgroundSize: '33.6px 33.6px',
        backgroundRepeat: 'no-repeat',
        width: '33.6px',
        height: '33.6px',
        backgroundPosition: '0 33.6px',
        animation: '$progressBottom 2s ease infinite',
        WebkitClipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
        clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
        position: 'relative',
        '&::after': {
            content: '""',
            position: 'absolute',
            width: '1.65px',
            height: '33.6px',
            left: '16px',
            backgroundImage: 'linear-gradient(#2e9e9e, transparent)',
        },
    },
    '@keyframes progressTop': {
        '95%, 100%': {
            backgroundPosition: '0 33.6px',
        },
    },
    '@keyframes progressBottom': {
        '95%, 100%': {
            backgroundPosition: '0 0',
        },
    },
    '@keyframes progressRotate': {
        '0%, 95%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(180deg)',
        },
    },
});

interface HourglassSpinnerProps {
    message?: string;
}

const HourglassSpinner: React.FC<HourglassSpinnerProps> = ({ message }) => {
    const classes = useStyles();

    return (
        <div className={classes.loadingContainer}>
            <div className={classes.progress}>
                <div className={classes.top}></div>
                <div className={classes.bottom}></div>
            </div>
            {message && (
                <Typography variant="body2" style={{ marginLeft: 16 }}>
                    {message}
                </Typography>
            )}
        </div>
    );
};

export default HourglassSpinner;
